import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";

export function BrowseProductCardSkeleton({ index = 0 }: { index?: number }) {
  return (
    <div
      className="overflow-hidden rounded-xl border border-border/50 bg-card/50 animate-fade-in opacity-0"
      style={{ animationFillMode: "forwards", animationDelay: `${index * 50}ms` }}
    >
      <Skeleton className="aspect-[4/3] w-full rounded-none" />
      <div className="p-3.5 space-y-3">
        <div className="space-y-2">
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-4 w-1/3" />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-6 w-6 rounded-full shrink-0" />
          <Skeleton className="h-4 w-28" />
        </div>
        <div className="flex items-center justify-between pt-2.5 border-t border-border/30">
          <Skeleton className="h-6 w-16" />
          <div className="flex gap-1.5">
            <Skeleton className="h-9 w-9 rounded-md" />
            <Skeleton className="h-9 w-9 rounded-md" />
            <Skeleton className="h-9 w-20 rounded-md" />
          </div>
        </div>
      </div>
    </div>
  );
}

type BrowseProductGridSkeletonProps = {
  /** Tailwind grid column classes, e.g. from Browse `gridCols` */
  gridClassName: string;
  /** Match filter rail: reserve 280px on lg+ when rail is visible */
  showFilterRailSpacer?: boolean;
  itemCount?: number;
  className?: string;
};

export function BrowseProductGridSkeleton({
  gridClassName,
  showFilterRailSpacer = true,
  itemCount = 12,
  className,
}: BrowseProductGridSkeletonProps) {
  return (
    <div className={cn("container py-5", className)} aria-busy="true" aria-label="Loading products">
      <div className="flex gap-6 items-start">
        {showFilterRailSpacer ? (
          <div className="hidden lg:block w-[280px] shrink-0" aria-hidden />
        ) : null}
        <div className="flex-1 min-w-0">
          <div className={cn("grid gap-3", gridClassName)}>
            {[...Array(itemCount)].map((_, i) => (
              <BrowseProductCardSkeleton key={i} index={i} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
